import { Alert, Button, Card, Field, PasswordInput } from "@nabble/ui";
import { useState } from "react";
import { PasswordChecklist } from "../../../../components/PasswordChecklist";
import { PasswordStrength } from "../../../../components/PasswordStrength";
import { PasswordViolationsAlert } from "../../../../components/PasswordViolationsAlert";
import { ForgotPasswordDialog } from "./ForgotPasswordDialog";
import { useChangePassword } from "./useChangePassword";

/** My account → Authentication → Password: change it, or get a link by email when it's forgotten. */
export function PasswordCard({ email, onChanged }: { email: string; onChanged: () => void }): React.JSX.Element {
  const [forgotOpen, setForgotOpen] = useState(false);
  const form = useChangePassword(onChanged);

  return (
    <Card id="password" className="nb-setting" padded={false}>
      <form className="nb-setting-row" onSubmit={(e) => void form.submit(e)} noValidate>
        <div>
          <div className="nb-setting-title">Password</div>
          <p className="nb-setting-desc">When you change it, we'll sign out your other open sessions.</p>
        </div>
        <div className="nb-setting-content" style={{ maxWidth: 420 }}>
          <Field label="Current password" error={form.currentError ?? undefined}>
            <PasswordInput autoComplete="current-password" value={form.current} onChange={(e) => form.setCurrent(e.target.value)} />
          </Field>
          <Field label="New password">
            <PasswordInput autoComplete="new-password" value={form.next} onChange={(e) => form.setNext(e.target.value)} />
          </Field>
          {form.next ? <PasswordStrength password={form.next} /> : null}
          <Field label="Confirm the new password">
            <PasswordInput autoComplete="new-password" value={form.confirm} onChange={(e) => form.setConfirm(e.target.value)} />
          </Field>
          {form.next || form.confirm ? <PasswordChecklist checks={form.checks} /> : null}
          {form.violations.length > 0 ? (
            <PasswordViolationsAlert title="The password doesn't meet the policy" violations={form.violations} />
          ) : form.error ? (
            <Alert tone="danger">{form.error}</Alert>
          ) : null}
          <div className="nb-row-between">
            <Button type="submit" label="Change password" loading={form.loading} disabled={!form.valid} />
            <button type="button" className="nb-link-btn" onClick={() => setForgotOpen(true)}>
              Forgot your current password?
            </button>
          </div>
        </div>
      </form>
      <ForgotPasswordDialog open={forgotOpen} email={email} onClose={() => setForgotOpen(false)} />
    </Card>
  );
}
